import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
var font = variables.font,
  global = variables.global;
export var notFound = /*#__PURE__*/css("padding:20px;font-weight:", font.h4FontWeight, ";text-align:center;");
export var agentProfile = /*#__PURE__*/css(".allhomes-breadcrumbs{padding:10px 0 0 16px;", media('>=tablet'), "{padding-bottom:15px;max-width:", global.desktopMinWidth, ";margin:0 auto;}", media('>=desktop'), "{padding:21px 0 18px 3px;}}");
export var banner = bgColor => /*#__PURE__*/css("display:flex;justify-content:center;align-items:center;position:sticky;top:0;width:100%;height:44px;max-height:44px;background-color:", bgColor, ";z-index:", global.layerOverlay, ";", media('>=desktop'), "{height:66px;max-height:66px;margin-bottom:9px;}");
export var bannerLogo = /*#__PURE__*/css("height:100%;max-height:100%;object-fit:cover;padding:4px;", media('>=desktop'), "{padding:12px;}");
export var body = {
  name: "y8aj3r",
  styles: "padding:0;"
};